export async function apiGet<T = any>(path: string, signal?: AbortSignal): Promise<T> {
  const resp = await fetch(`/api${path}`, { signal });
  if (!resp.ok) throw new Error(`API ${path}: ${resp.status}`);
  return resp.json();
}

export async function apiPost<T = any>(
  path: string,
  body?: any,
): Promise<T> {
  const resp = await fetch(`/api${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!resp.ok) throw new Error(`API ${path}: ${resp.status}`);
  return resp.json();
}

export async function apiPut<T = any>(
  path: string,
  body?: any,
): Promise<T> {
  const resp = await fetch(`/api${path}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!resp.ok) throw new Error(`API ${path}: ${resp.status}`);
  return resp.json();
}

// ---------------------------------------------------------------------------
// Investment book (koru-invest) API
// ---------------------------------------------------------------------------

import type {
  InvestOverview,
  InvestHoldingsResponse,
  InvestRebalancesResponse,
  InvestSimulateResponse,
  SupplyDemandResponse,
  KisMetricsResponse,
} from "./types";

export function fetchInvestOverview(): Promise<InvestOverview> {
  return apiGet<InvestOverview>("/invest/overview");
}

export function fetchInvestHoldings(): Promise<InvestHoldingsResponse> {
  return apiGet<InvestHoldingsResponse>("/invest/holdings");
}

export function fetchInvestRebalances(
  limit = 50,
): Promise<InvestRebalancesResponse> {
  return apiGet<InvestRebalancesResponse>(
    `/invest/rebalances${limit ? `?limit=${limit}` : ""}`,
  );
}

export function simulateInvestRebalance(): Promise<InvestSimulateResponse> {
  return apiPost<InvestSimulateResponse>("/invest/rebalance/simulate");
}

export function fetchSupplyDemandData(): Promise<SupplyDemandResponse> {
  return apiGet<SupplyDemandResponse>("/macro/supply-demand");
}

export function fetchKisMetrics(): Promise<KisMetricsResponse> {
  return apiGet<KisMetricsResponse>("/kis/metrics");
}
